import { useParams } from 'react-router-dom';
export const usePageParams = () => useParams();